export * from './GroupOrderIntroFooter';
